import cs from "classnames";
import PropTypes from "prop-types";
import React, { memo, useEffect, useState } from "react";
import "./header-container.scss";
import { Helmet } from "react-helmet";

const showRef = (ref) => {
  if (ref.current.id === "show-primary") {
    ref.current.id = "nav-primary";
  } else {
    ref.current.id = "show-primary";
  }
};
const HeaderContainer = (props) => {
  const primaryRef = React.createRef();
  const secondaryRef = React.createRef();

  const [submenuOpen, setSubmenuOpen] = useState("");
  const toggleSubmenu = (menuItem) => {
    if (submenuOpen == menuItem) {
      if (menuItem == "soc" || menuItem == "noc" || menuItem == "coc") {
        setSubmenuOpen("communities");
      } else if (menuItem == "blog") {
        setSubmenuOpen("cesis");
      } else {
        setSubmenuOpen("");
      }
    } else {
      setSubmenuOpen(menuItem);
    }
  };

  console.log("test ------");
  console.log(submenuOpen);

  // needed if sub-submenu clicks need to collapse sub-menus
  const closeSubmenus = () => setSubmenuOpen("");

  return (
    <div className={cs("on-title-header")} id="header-contianer">
      <Helmet>
        <link
          rel="stylesheet"
          href="//fonts.googleapis.com/css?family=Rouge+Script%7CMonsieur+La+Doulaise%7CMiss+Fajardose%7CJosefin+Sans%7CQuattrocento"
        />
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <title>Orange County Luxury Real Estate | The Cesi Pagano Team</title>
        <meta
          name="description"
          content="Contact The Cesi Pagano Team for help buying, selling or leasing Orange County luxury real estate. You won't find a better resource online or offline."
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link rel="canonical" href="https://www.cesipagano.com/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Orange County Luxury Real Estate | The Cesi Pagano Team"
        />
        <meta
          property="og:description"
          content="Contact The Cesi Pagano Team for help buying, selling or leasing Orange County luxury real estate. You won't find a better resource online or offline."
        />
        <meta property="og:url" content="https://www.cesipagano.com/" />
        <meta property="og:site_name" content="Cesi Pagano &amp; Associates" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/cesiandassociates/"
        />
        <meta
          property="article:modified_time"
          content="2013-11-04T23:55:28+00:00"
        />
        <meta
          property="og:image"
          content="https://i1.wp.com/www.cesipagano.com/wp-content/uploads/2019/02/cesi-black-font.png?fit=1557%2C452&amp;ssl=1"
        />
        <meta property="og:image:width" content="1557" />
        <meta property="og:image:height" content="452" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Cesipagano" />
        <meta
          name="google-site-verification"
          content="w_rSQ6wjNW5O0Ln3Fwuxhe3t4SCBcjdMkdNz8vl6L0w"
        />
        <meta name="geo.placename" content="Laguna Niguel" />
        <meta name="geo.position" content="33.568353;-117.67133" />
        <meta name="geo.region" content="United States (US)" />

        <link rel="dns-prefetch" href="//secure.gravatar.com" />
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
        <link rel="dns-prefetch" href="//s.w.org" />
        <link rel="dns-prefetch" href="//v0.wordpress.com" />
        <link rel="dns-prefetch" href="//jetpack.wordpress.com" />
        <link rel="dns-prefetch" href="//s0.wp.com" />
        <link rel="dns-prefetch" href="//s1.wp.com" />
        <link rel="dns-prefetch" href="//s2.wp.com" />
        <link rel="dns-prefetch" href="//public-api.wordpress.com" />
        <link rel="dns-prefetch" href="//0.gravatar.com" />
        <link rel="dns-prefetch" href="//1.gravatar.com" />
        <link rel="dns-prefetch" href="//2.gravatar.com" />
        <link rel="dns-prefetch" href="//i0.wp.com" />
        <link rel="dns-prefetch" href="//i1.wp.com" />
        <link rel="dns-prefetch" href="//i2.wp.com" />
        <link rel="dns-prefetch" href="//search.cesipagano.com" />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Cesi Pagano &amp; Associates » Feed"
          href="https://www.cesipagano.com/feed/"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Cesi Pagano &amp; Associates » Comments Feed"
          href="https://www.cesipagano.com/comments/feed/"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Cesi Pagano &amp; Associates » Home Comments Feed"
          href="https://www.cesipagano.com/home/feed/"
        />

        <link
          rel="stylesheet"
          id="idxforza-widgets-css"
          href="https://www.cesipagano.com/wp-content/plugins/idxforza/assets/css/idxforza-widgets.css?ver=5.6"
          type="text/css"
          media="all"
        />
        <link
          rel="stylesheet"
          id="re-pro-widgets-css"
          href="https://www.cesipagano.com/wp-content/plugins/re-pro/assets/css/re-pro-widgets.min.css?ver=5.6"
          type="text/css"
          media="all"
        />
        <link
          rel="stylesheet"
          id="monsterinsights-popular-posts-style-css"
          href="https://www.cesipagano.com/wp-content/plugins/google-analytics-for-wordpress/assets/css/frontend.min.css?ver=7.14.0"
          type="text/css"
          media="all"
        />
        <link
          rel="stylesheet"
          id="dashicons-css"
          href="https://www.cesipagano.com/wp-includes/css/dashicons.min.css?ver=5.6"
          type="text/css"
          media="all"
        />
        <link
          rel="stylesheet"
          id="social-logos-css"
          href="https://www.cesipagano.com/wp-content/plugins/jetpack/_inc/social-logos/social-logos.min.css?ver=9.3"
          type="text/css"
          media="all"
        />
        <link
          rel="stylesheet"
          id="jetpack_css-css"
          href="https://www.cesipagano.com/wp-content/plugins/jetpack/css/jetpack.css?ver=9.3"
          type="text/css"
          media="all"
        />
        <link
          rel="https://api.w.org/"
          href="https://www.cesipagano.com/wp-json/"
        />
        <link
          rel="alternate"
          type="application/json"
          href="https://www.cesipagano.com/wp-json/wp/v2/pages/74"
        />
        <link
          rel="EditURI"
          type="application/rsd+xml"
          title="RSD"
          href="https://www.cesipagano.com/xmlrpc.php?rsd"
        />
        <link
          rel="wlwmanifest"
          type="application/wlwmanifest+xml"
          href="https://www.cesipagano.com/wp-includes/wlwmanifest.xml"
        />
        <link rel="shortlink" href="https://wp.me/P3Slq7-1c" />
        <link
          rel="alternate"
          type="application/json+oembed"
          href="https://www.cesipagano.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.cesipagano.com%2F"
        />
        <link
          rel="alternate"
          type="text/xml+oembed"
          href="https://www.cesipagano.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.cesipagano.com%2F&amp;format=xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Listings RSS"
          href="https://syndication.idxbroker.com/rss/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Listings Advanced RSS"
          href="https://syndication.idxbroker.com/rss-advanced/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Home Gain Feed"
          href="https://syndication.idxbroker.com/homegain/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Hotpads Feed"
          href="https://syndication.idxbroker.com/hotpads/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="City Cribs Feed"
          href="https://syndication.idxbroker.com/citycribs/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Oodle Feed"
          href="https://syndication.idxbroker.com/oodle/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Luxury Homes Feed"
          href="https://syndication.idxbroker.com/luxuryhomes/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Front Door Feed"
          href="https://syndication.idxbroker.com/frontdoor/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Rentals Feed"
          href="https://syndication.idxbroker.com/rentals/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Propbot Feed"
          href="https://syndication.idxbroker.com/propbot/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Gumiyo Feed"
          href="https://syndication.idxbroker.com/gumiyo/2045d88f6d.xml"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Live Deal Feed"
          href="https://syndication.idxbroker.com/livedeal/2045d88f6d.xml"
        />
        <link
          rel="icon"
          href="https://i0.wp.com/www.cesipagano.com/wp-content/uploads/2019/06/cropped-cesi-pagano-icon.png?fit=32%2C32&amp;ssl=1"
          sizes="32x32"
        />
        <link
          rel="icon"
          href="https://i0.wp.com/www.cesipagano.com/wp-content/uploads/2019/06/cropped-cesi-pagano-icon.png?fit=192%2C192&amp;ssl=1"
          sizes="192x192"
        />
        <link
          rel="apple-touch-icon"
          href="https://i0.wp.com/www.cesipagano.com/wp-content/uploads/2019/06/cropped-cesi-pagano-icon.png?fit=180%2C180&amp;ssl=1"
        />
        <meta
          name="msapplication-TileImage"
          content="https://i0.wp.com/www.cesipagano.com/wp-content/uploads/2019/06/cropped-cesi-pagano-icon.png?fit=270%2C270&amp;ssl=1"
        />

        <link
          type="text/css"
          rel="stylesheet"
          charset="UTF-8"
          href="https://translate.googleapis.com/translate_static/css/translateelement.css"
        />
        <script
          type="text/javascript"
          charset="UTF-8"
          src="https://translate.googleapis.com/translate_static/js/element/main.js"
        ></script>
        <script
          type="text/javascript"
          charset="UTF-8"
          src="https://translate.googleapis.com/element/TE_20201130_00/e/js/element/element_main.js"
        ></script>
      </Helmet>
      <div className="site-container">
        <header className="site-header">
          <div className="wrap">
            <div className="title-area">
              <p className="site-title">
                <a href="https://www.cesipagano.com/"></a>
              </p>
              <p className="site-description">
                Orange County Luxury Real Estate
              </p>
            </div>
          </div>
        </header>
        <button
          className="menu-toggle nav-primary activated"
          aria-expanded="false"
          aria-pressed="false"
          role="button"
          id="mobile-nav-primary"
          onClick={() => {
            console.log(primaryRef);
            showRef(primaryRef);
          }}
        >
          Menu
        </button>
        <nav
          className="nav-primary"
          aria-label="Main"
          id="nav-primary"
          ref={primaryRef}
        >
          <div className="wrap">
            <ul
              id="menu-top-left"
              className="menu genesis-nav-menu menu-primary"
            >
              {/*<li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-2755940">
                <a href="https://www.homelight.com/trade-in">
                  <span>Trade In</span>
                </a>
        </li>*/}
              <li
                id="menu-item-2755939"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-2755939"
              >
                <a href="https://www.cesipagano.com/sellers/">
                  <span>SELLERS</span>
                </a>
                {/* Na klik ovog buttona otvoriu sub menu ispod njega */}
                <button
                  onClick={() => toggleSubmenu("sellers")}
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul
                  className={
                    submenuOpen === "sellers" ? "sub-menu active" : "sub-menu "
                  }
                >
                  <li
                    id="menu-item-2879013"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2879013"
                  >
                    <a href="https://www.cesipagano.com/cesi-pagano-associates-safe-seller-program/">
                      <span>Safe Seller Program</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-2955055"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2955055"
                  >
                    <a href="https://www.cesipagano.com/guaranteed-buyout-program/">
                      <span>Guaranteed Buyout Program</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731498"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731498"
                  >
                    <a href="https://www.cesipagano.com/sellers/how-much-is-my-home-worth/">
                      <span>How Much is My Home Worth?</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731500"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731500"
                  >
                    <a href="https://www.cesipagano.com/sellers/short-sales-foreclosures/">
                      <span>Foreclosures &amp; Short Sales For Sellers</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1737400"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1737400"
                  >
                    <a href="https://search.cesipagano.com/idx/featured">
                      <span>Featured Listings</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731502"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731502"
                  >
                    <a href="https://search.cesipagano.com/idx/soldpending">
                      <span>Just Sold</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731523"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731523"
                  >
                    <a href="https://www.cesipagano.com/resources/">
                      <span>Resources</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-3000001"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-3000001"
                  >
                    <a href="https://www.cesipagano.com/sellers/easy-exit-guarantee-sellers/">
                      <span>EASY EXIT GUARANTEE</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-2755940"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-2755940"
              >
                <a href="https://www.cesipagano.com/buyers/">
                  <span>BUYERS</span>
                </a>
                <button
                  onClick={() => toggleSubmenu("buyers")}
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul
                  className={
                    submenuOpen === "buyers" ? "sub-menu active" : "sub-menu "
                  }
                >
                  <li
                    id="menu-item-2879014"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2879014"
                  >
                    <a href="https://www.cesipagano.com/cesi-pagano-associates-virtual-home-buying-program/">
                      <span>Virtual Home Buying Program</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731506"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731506"
                  >
                    <a href="https://search.cesipagano.com/idx/search/homes">
                      <span>MLS Search</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731507"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731507"
                  >
                    <a href="https://search.cesipagano.com/idx/featured">
                      <span>Featured Listings</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-2999423"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2999423"
                  >
                    <a href="https://www.cesipagano.com/build-your-dream-home/">
                      <span>Build Your Dream Home</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731508"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731508"
                  >
                    <a href="https://www.cesipagano.com/buyers/international-buyers/">
                      <span>International Buyers</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731524"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731524"
                  >
                    <a href="https://www.cesipagano.com/buyers/global-home-search/">
                      <span>Global Home Search</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731525"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731525"
                  >
                    <a href="https://www.cesipagano.com/buyers/relocation/">
                      <span>Relocation</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731509"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731509"
                  >
                    <a href="https://www.cesipagano.com/buyers/loan-prequalification/">
                      <span>Loan Prequalification</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731562"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731562"
                  >
                    <a href="https://www.cesipagano.com/buyers/short-sales-foreclosures/">
                      <span>Short Sales &amp; Foreclosures For Buyers</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-3000000"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-3000000"
                  >
                    <a href="https://www.cesipagano.com/buyers/easy-exit-guarantee-buyers/">
                      <span>EASY EXIT GUARANTEE</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-1731495"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731495"
              >
                <a href="https://www.cesipagano.com/community-guides/">
                  <span>COMMUNITIES</span>
                </a>
                <button
                  onClick={() => toggleSubmenu("communities")}
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul
                  className={
                    submenuOpen === "communities" ||
                    submenuOpen === "soc" ||
                    submenuOpen === "noc" ||
                    submenuOpen === "coc"
                      ? "sub-menu active"
                      : "sub-menu "
                  }
                >
                  <li
                    id="menu-item-1731531"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731531"
                  >
                    <a href="https://www.cesipagano.com/communities/south-orange-county/">
                      <span>South Orange County</span>
                    </a>
                    <button
                      onClick={() => toggleSubmenu("soc")}
                      className="sub-menu-toggle"
                      aria-expanded="false"
                      aria-pressed="false"
                      role="button"
                    >
                      <span className="screen-reader-text">Menu</span>
                    </button>
                    <ul
                      className={
                        submenuOpen === "soc"
                          ? "sub-menu additional-menu active"
                          : "sub-menu additional-menu "
                      }
                    >
                      <li
                        id="menu-item-1731569"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731569"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/homes-for-sale-aliso-viejo/">
                          <span>Aliso Viejo</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731570"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731570"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/real-estate-coto-de-caza/">
                          <span>Coto De Caza</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731571"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731571"
                      >
                        <a href="https://www.cesipagano.com/communities/coastal-orange-county/dana-point-real-estate/">
                          <span>Dana Point</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731572"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731572"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/foothill-ranch-homes-for-sale/">
                          <span>Foothill Ranch</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731564"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731564"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/real-estate-sales-irvine/">
                          <span>Irvine</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731573"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731573"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/homes-ladera-ranch-sales/">
                          <span>Ladera Ranch</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731574"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731574"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/laguna-hills-real-estate/">
                          <span>Laguna Hills</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731575"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731575"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/sales-laguna-niguel-real-estate/">
                          <span>Laguna Niguel</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731576"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731576"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/lake-forest-homes-for-sale/">
                          <span>Lake Forest</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731578"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731578"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/mission-viejo-homes-sale/">
                          <span>Mission Viejo</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731577"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731577"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/rancho-mission-viejo-real-estate-sale/">
                          <span>Rancho Mission Viejo</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731673"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731673"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/homes-sale-rancho-santa-margarita/">
                          <span>Rancho Santa Margarita</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731579"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731579"
                      >
                        <a href="https://www.cesipagano.com/communities/coastal-orange-county/san-clemente-real-estate/">
                          <span>San Clemente</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731580"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731580"
                      >
                        <a href="https://www.cesipagano.com/communities/south-orange-county/homes-san-juan-capistrano/">
                          <span>San Juan Capistrano</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-1731533"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731533"
                  >
                    <a href="https://www.cesipagano.com/communities/coastal-orange-county/">
                      <span>Coastal Orange County</span>
                    </a>
                    <button
                      onClick={() => toggleSubmenu("coc")}
                      className="sub-menu-toggle"
                      aria-expanded="false"
                      aria-pressed="false"
                      role="button"
                    >
                      <span className="screen-reader-text">Menu</span>
                    </button>
                    <ul
                      className={
                        submenuOpen === "coc"
                          ? "sub-menu additional-menu active"
                          : "sub-menu additional-menu "
                      }
                    >
                      <li
                        id="menu-item-1731565"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731565"
                      >
                        <a href="https://www.cesipagano.com/communities/coastal-orange-county/dana-point-real-estate/">
                          <span>Dana Point</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731566"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731566"
                      >
                        <a href="https://www.cesipagano.com/communities/coastal-orange-county/real-estate-laguna-beach/">
                          <span>Laguna Beach</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731567"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731567"
                      >
                        <a href="https://www.cesipagano.com/communities/coastal-orange-county/real-estate-newport-beach/">
                          <span>Newport Beach</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1731568"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731568"
                      >
                        <a href="https://www.cesipagano.com/communities/coastal-orange-county/san-clemente-real-estate/">
                          <span>San Clemente</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-1731532"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731532"
                  >
                    <a href="https://www.cesipagano.com/communities/north-orange-county/">
                      <span>North Orange County</span>
                    </a>
                    <button
                      onClick={() => toggleSubmenu("noc")}
                      className="sub-menu-toggle"
                      aria-expanded="false"
                      aria-pressed="false"
                      role="button"
                    >
                      <span className="screen-reader-text">Menu</span>
                    </button>
                    <ul
                      className={
                        submenuOpen === "noc"
                          ? "sub-menu additional-menu active"
                          : "sub-menu additional-menu "
                      }
                    >
                      <li
                        id="menu-item-1731563"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731563"
                      >
                        <a href="https://www.cesipagano.com/communities/north-orange-county/realty-costa-mesa/">
                          <span>Costa Mesa</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-1731475"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731475 moved-item toggle-on"
              >
                <a href="https://www.cesipagano.com/our-team/">
                  <span>OUR TEAM</span>
                </a>
                <button
                  onClick={() => toggleSubmenu("team")}
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul
                  className={
                    submenuOpen === "team" ? "sub-menu active" : "sub-menu"
                  }
                >
                  <li
                    id="menu-item-1731512"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731512"
                  >
                    <a href="https://www.cesipagano.com/our-team/meet-cesi-pagano/">
                      <span>Meet Cesi Pagano</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731513"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731513"
                  >
                    <a href="https://www.cesipagano.com/our-team/meet-the-associates/">
                      <span>Meet The Associates</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731514"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731514"
                  >
                    <a href="https://www.cesipagano.com/our-team/about-keller-williams/">
                      <span>Keller Williams International</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731553"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731553"
                  >
                    <a href="https://www.cesipagano.com/our-team/join-our-team/">
                      <span>Join Our Team</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731653"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731653"
                  >
                    <a href="/testimonials/">
                      <span>Reviews</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-1731474"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731474 moved-item toggle-on"
              >
                <a href="https://www.cesipagano.com/cesis-corner/">
                  <span>CESI’S CORNER</span>
                </a>
                <button
                  onClick={() => toggleSubmenu("cesis")}
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul
                  className={
                    submenuOpen === "cesis" || submenuOpen === "blog"
                      ? "sub-menu active"
                      : "sub-menu"
                  }
                >
                  <li
                    id="menu-item-1731555"
                    className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-has-children menu-item-1731555"
                  >
                    <a href="https://www.cesipagano.com/blog/category/blog/">
                      <span>Blog</span>
                    </a>
                    <button
                      onClick={() => toggleSubmenu("blog")}
                      className="sub-menu-toggle"
                      aria-expanded="false"
                      aria-pressed="false"
                      role="button"
                    >
                      <span className="screen-reader-text">Menu</span>
                    </button>
                    <ul
                      className={
                        submenuOpen == "contact"
                          ? "sub-menu additional-menu active"
                          : "sub-menu additional-menu"
                      }
                    >
                      <li
                        id="menu-item-1731718"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1731718"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/listing-blog/">
                          <span>Listing Blog</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1737128"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1737128"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/events-blog/">
                          <span>Events Blog</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1737129"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1737129"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/real-estate-essentials-blog/">
                          <span>Real Estate Essentials Blog</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1737250"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1737250"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/community-blog/">
                          <span>Community Blog</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-1731515"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731515"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/vendors/">
                      <span>Vendor Connections</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731556"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731556"
                  >
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.realtor.com/news/"
                    >
                      <span>Real Estate News</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731517"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731517"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/concierge-services/">
                      <span>Concierge Services</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731581"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731581"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/california-insider/">
                      <span>California Insider</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731627"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731627"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/video-testimonials/">
                      <span>Video Testimonials</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-1731473"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731473 moved-item toggle-on"
              >
                <a href="https://www.cesipagano.com/contact/">
                  <span>CONTACT US</span>
                </a>
                <button
                  onClick={() => toggleSubmenu("contact")}
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul
                  className={
                    submenuOpen == "contact" ? "sub-menu active" : "sub-menu"
                  }
                >
                  <li
                    id="menu-item-1731561"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731561"
                  >
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://goo.gl/BNQAhM"
                    >
                      <span>Recommend Us</span>
                    </a>
                  </li>
                </ul>
              </li>
              {/* Hide this before mobile */}
            </ul>
          </div>
        </nav>
        {/* Hide this on mobile */}
        <nav
          className="nav-secondary"
          aria-label="Secondary"
          id="nav-secondary"
          ref={secondaryRef}
        >
          <div className="wrap">
            <ul
              id="menu-top-right"
              className="menu genesis-nav-menu menu-secondary"
            >
              <li
                id="menu-item-1731475"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731475"
              >
                <a href="https://www.cesipagano.com/our-team/">
                  <span>OUR TEAM</span>
                </a>
                <button
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul className="sub-menu">
                  <li
                    id="menu-item-1731512"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731512"
                  >
                    <a href="https://www.cesipagano.com/our-team/meet-cesi-pagano/">
                      <span>Meet Cesi Pagano</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731513"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731513"
                  >
                    <a href="https://www.cesipagano.com/our-team/meet-the-associates/">
                      <span>Meet The Associates</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731514"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731514"
                  >
                    <a href="https://www.cesipagano.com/our-team/about-keller-williams/">
                      <span>Keller Williams International</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731553"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731553"
                  >
                    <a href="https://www.cesipagano.com/our-team/join-our-team/">
                      <span>Join Our Team</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731653"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731653"
                  >
                    <a href="/testimonials/">
                      <span>Reviews</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-1731474"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731474"
              >
                <a href="https://www.cesipagano.com/cesis-corner/">
                  <span>CESI’S CORNER</span>
                </a>
                <button
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul className="sub-menu">
                  <li
                    id="menu-item-1731555"
                    className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-has-children menu-item-1731555"
                  >
                    <a href="https://www.cesipagano.com/blog/category/blog/">
                      <span>Blog</span>
                    </a>
                    <button
                      className="sub-menu-toggle"
                      aria-expanded="false"
                      aria-pressed="false"
                      role="button"
                    >
                      <span className="screen-reader-text">Menu</span>
                    </button>
                    <ul className="sub-menu additional-menu">
                      <li
                        id="menu-item-1731718"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1731718"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/listing-blog/">
                          <span>Listing Blog</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1737128"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1737128"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/events-blog/">
                          <span>Events Blog</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1737129"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1737129"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/real-estate-essentials-blog/">
                          <span>Real Estate Essentials Blog</span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1737250"
                        className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1737250"
                      >
                        <a href="https://www.cesipagano.com/blog/category/blog/community-blog/">
                          <span>Community Blog</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-1731515"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731515"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/vendors/">
                      <span>Vendor Connections</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731556"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731556"
                  >
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.realtor.com/news/"
                    >
                      <span>Real Estate News</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731517"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731517"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/concierge-services/">
                      <span>Concierge Services</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731581"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731581"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/california-insider/">
                      <span>California Insider</span>
                    </a>
                  </li>
                  <li
                    id="menu-item-1731627"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1731627"
                  >
                    <a href="https://www.cesipagano.com/cesis-corner/video-testimonials/">
                      <span>Video Testimonials</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-1731473"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1731473"
              >
                <a href="https://www.cesipagano.com/contact/">
                  <span>CONTACT US</span>
                </a>
                <button
                  className="sub-menu-toggle"
                  aria-expanded="false"
                  aria-pressed="false"
                  role="button"
                >
                  <span className="screen-reader-text">Menu</span>
                </button>
                <ul className="sub-menu">
                  <li
                    id="menu-item-1731561"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1731561"
                  >
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://goo.gl/BNQAhM"
                    >
                      <span>Recommend Us</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        {/* Hide this on mobile */}
        <div className="header-left widget-area hide">
          <section
            id="jetpack_widget_social_icons-3"
            className="widget jetpack_widget_social_icons"
          >
            <div className="widget-wrap">
              <h5 className="widget-title widgettitle">FOLLOW US ON</h5>
              <ul
                className="jetpack-social-widget-list size-small"
                id="sc-icons"
              >
                <li className="jetpack-social-widget-item">
                  <a
                    href="https://www.facebook.com/cesiandassociates/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="screen-reader-text">Facebook</span>
                    <svg
                      className="icon icon-facebook"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use
                        href="#icon-facebook"
                        xlinkHref="#icon-facebook"
                      ></use>
                    </svg>{" "}
                  </a>
                </li>
                <li className="jetpack-social-widget-item">
                  <a
                    href="https://twitter.com/Cesipagano"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="screen-reader-text">Twitter</span>
                    <svg
                      className="icon icon-twitter"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#icon-twitter" xlinkHref="#icon-twitter"></use>
                    </svg>{" "}
                  </a>
                </li>
                <li className="jetpack-social-widget-item">
                  <a
                    href="https://www.youtube.com/channel/UCvsFxwZUDEnWNgtQwZV5-Vw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="screen-reader-text">YouTube</span>
                    <svg
                      className="icon icon-youtube"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#icon-youtube" xlinkHref="#icon-youtube"></use>
                    </svg>{" "}
                  </a>
                </li>
                <li className="jetpack-social-widget-item">
                  <a
                    href="https://linkedin.com/pub/cesi-pagano/5/7a/728"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="screen-reader-text">LinkedIn</span>
                    <svg
                      className="icon icon-linkedin"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use
                        href="#icon-linkedin"
                        xlinkHref="#icon-linkedin"
                      ></use>
                    </svg>{" "}
                  </a>
                </li>
                <li className="jetpack-social-widget-item">
                  <a
                    href="https://instagram.com/cesiandassociates/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="screen-reader-text">Instagram</span>
                    <svg
                      className="icon icon-instagram"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use
                        href="#icon-instagram"
                        xlinkHref="#icon-instagram"
                      ></use>
                    </svg>{" "}
                  </a>
                </li>
                <li className="jetpack-social-widget-item">
                  <a
                    href="https://www.pinterest.com/cesipagano"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="screen-reader-text">Pinterest</span>
                    <svg
                      className="icon icon-pinterest"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use
                        href="#icon-pinterest"
                        xlinkHref="#icon-pinterest"
                      ></use>
                    </svg>{" "}
                  </a>
                </li>
                <li className="jetpack-social-widget-item">
                  <a
                    href="https://app.kw.com/KW2U5Q5J6/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      className="icon icon-chain"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#icon-chain" xlinkHref="#icon-chain"></use>
                    </svg>{" "}
                  </a>
                </li>
              </ul>
            </div>
          </section>
        </div>
        <div className="right-header widget-area">
          <section id="search-5" className="widget widget_search">
            <div className="widget-wrap">
              <form
                className="search-form"
                method="get"
                action="https://www.cesipagano.com/"
                role="search"
              >
                <input
                  className="search-form-input"
                  type="search"
                  name="s"
                  id="searchform-1"
                  placeholder="Search this website"
                />
                <input
                  className="search-form-submit"
                  type="submit"
                  value="Search"
                />
                <meta content="https://www.cesipagano.com/?s={s}" />
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

HeaderContainer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.any,
  }),
};

HeaderContainer.defaultProps = { location: { pathname: "" } };

export default memo(HeaderContainer);
